const HUBSPOT_BANNER_ID = 'hs-eu-cookie-confirmation';

// The Hubspot cookie banner starts translated 200vh below the viewport (entry animation) and Hubspot
//  calls focus() on it as soon as it mounts. Without preventScroll the browser scrolls the page to reveal
//  the focused element, so the page behind the banner jumps toward the bottom (most visible in private
//  mode where there is no saved consent choice and the banner opens on every load).
//  Hubspot's script is third party so wrap focus for the banner (and anything inside it) only.
function preventHubspotBannerFocusScroll()
{
  const nativeFocus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function (options)
  {
    if (
      this.id === HUBSPOT_BANNER_ID ||
      this.closest?.(`#${HUBSPOT_BANNER_ID}`)
    )
    {
      return nativeFocus.call(this, { ...options, preventScroll: true });
    }

    return nativeFocus.call(this, options);
  };
}

// GTM default to consent granted

export function addConsentListeners()
{
  // Needs to be in place before Hubspot loads and opens the banner
  preventHubspotBannerFocusScroll();

  const _gtm = (globalThis.dataLayer = globalThis.dataLayer || []);
  _gtm.push({
    event: 'consent',
    type: 'default',
    data: {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
    },
  });

  // Hubspot Consent banner listener
  const _hsq = (globalThis._hsq = globalThis._hsq || []);
  _hsq.push([
    'addPrivacyConsentListener',
    function (consent)
    {
      const hasAnalyticsConsent =
        consent?.allowed || consent?.categories?.analytics;
      const hasAdsConsent =
        consent?.allowed || consent?.categories?.advertisement;

      // Push consent data to Google Tag Manager
      _gtm.push({
        event: 'consent',
        type: 'update',
        data: {
          ad_storage: hasAdsConsent ? 'granted' : 'denied',
          analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied',
          ad_user_data: hasAdsConsent ? 'granted' : 'denied',
          ad_personalization: hasAdsConsent ? 'granted' : 'denied',
        },
      });

      // Opt out of posthog if consent is not given
      if (!hasAnalyticsConsent || !hasAdsConsent)
      {
        // Exposed by the angular apps
        const _posthog = (globalThis.posthog = globalThis.posthog || []);
        _posthog.opt_out_capturing();
      }
    },
  ]);
}
